import { graphql, useStaticQuery } from "gatsby";
import { AboutFounderQuery } from "./query.generated";

export type CMSFounderData = AboutFounderQuery["cms"]["site"];

export function useStaticFounderQuery(): CMSFounderData {
  const data = useStaticQuery<AboutFounderQuery>(
    graphql`
      query AboutFounder {
        cms {
          site(hostname: "www.italymondo.com") {
            aboutPage: pages(contentType: "italymondo_about.IMAboutPage") {
              ... on CMS_IMAboutPage {
                founderCta {
                  page {
                    url
                  }
                  title
                }
                founderDescription
                founderMedia {
                  ... on CMS_MediaImagesBlock {
                    __typename
                    images {
                      image {
                        alt
                        url
                        urlSharp {
                          childImageSharp {
                            gatsbyImageData(placeholder: BLURRED, width: 900)
                          }
                        }
                      }
                    }
                  }
                  ... on CMS_TestimonialsBlock {
                    __typename
                    testimonials {
                      testimonial {
                        date
                        longMessage
                        name
                        photo {
                          alt
                          url
                          urlSharp {
                            childImageSharp {
                              gatsbyImageData(
                                height: 60
                                width: 60
                                placeholder: BLURRED
                              )
                            }
                          }
                        }
                        sourceDetail {
                          logo {
                            title
                            url
                          }
                          url
                        }
                      }
                    }
                  }
                }
                founderMediaPlacement
                founderSectionName
                founderSignature {
                  url
                }
                founderTitle
              }
            }
          }
        }
      }
    `
  );
  return data.cms.site;
}
